import { Box } from "@mui/material"
import type { FC } from "react"
import React from "react"
import { useFormContext } from "react-hook-form"

import { FormAutocomplete } from "@/components/UiKit"
import { RecipientType } from "@/screens/Pricing/constants"
import { recipientTypeTypeLabelMap } from "@/screens/Pricing/constants/priceChangeLabelMap"
import type { ReSendToIndividualSchemaFormValues } from "@/screens/Pricing/schema/SendPriceChangeSchema"
import type { Option } from "@/types/form-fields"

const recipientTypeOptions = Object.values(RecipientType).map((value) => ({
  value: value.toString(),
  label: recipientTypeTypeLabelMap.get(value) ?? value,
}))

interface ReSendIndividualFormProps {
  customerOptions: Option<string>[]
  contactOptions: Option<string>[]
}

const ReSendIndividualForm: FC<ReSendIndividualFormProps> = ({ customerOptions, contactOptions }) => {
  const { control, watch } = useFormContext<ReSendToIndividualSchemaFormValues>()

  const recipientType = watch("recipientType")

  return (
    <Box className='my-10 flex flex-row gap-3'>
      <Box className='w-1/3'>
        <FormAutocomplete
          control={control}
          name='recipientType'
          label='Recipient Type'
          placeholder='Select Recipient Type...'
          options={recipientTypeOptions}
          required
          data-testid='resend-individual-dialog.recipient-type-field'
        />
      </Box>
      <Box className='w-2/3'>
        {recipientType === RecipientType.Contact && (
          <FormAutocomplete
            control={control}
            name='contactId'
            label='Recipient'
            placeholder='Select Recipient...'
            options={contactOptions}
            required
            data-testid='resend-individual-dialog.contact-field'
          />
        )}

        {recipientType === RecipientType.Customer && (
          <FormAutocomplete
            control={control}
            name='customerId'
            label='Recipient'
            placeholder='Select Recipient...'
            options={customerOptions}
            required
            data-testid='resend-individual-dialog.customer-field'
          />
        )}
      </Box>
    </Box>
  )
}

export default ReSendIndividualForm
